import React from 'react'
import {Accordion as ChakraAccordion, AccordionProps} from '@chakra-ui/react'

/**
 * @name Accordion
 *
 * @description
 * Component that wraps Chakra UI's Accordion component.
 *
 * @component
 * @param {AccordionProps} props - The properties passed to the Accordion component.
 *
 * @returns {JSX.Element} The rendered Accordion component.
 *
 * @example
 * ```tsx
 * <Accordion allowToggle>
 *   <AccordionItem title={title}>{children}</AccordionItem>
 * </Accordion>
 * ```
 */
const Accordion = (props: AccordionProps): JSX.Element => {
    return (
        <ChakraAccordion {...props} data-testid="accordion">
            {props.children}
        </ChakraAccordion>
    )
}

export {Accordion}
